import React, { useEffect, useState } from "react";
import getApi from "./api/getApi";
import { BASEURL } from "./constant";
import CircularProgress from "./components/CircularProgress";
import bannerImg from "./images/banner.png";
import Carousel from "react-bootstrap/Carousel";

export default function NmaasHome() {
  const [eventCount, setEventCount] = useState({ count: 617, pcount: 0 });
  const [showProgress, setShowProgress] = useState(false);
  const userName = localStorage.getItem("userName");

  useEffect(() => {
    const getCompleteEvents = async () => {
      setShowProgress(true);
      const response = await getApi(`${BASEURL}/get_completed_event_count`);
      setShowProgress(false);
      if (response && response.count >= 0) {
        setEventCount({
          count: eventCount.count + response.count,
          pcount: eventCount.pcount + response.pcount,
        });
      } else {
        console.log(response);
      }
    };
    getCompleteEvents();
  }, []);

  return (
    <div
      className="nmaas-hero-banner position-relative text-white d-flex flex-column justify-content-center align-items-start w-100 m-0 p-0"
      style={{
        height: "100vh",
        backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${bannerImg})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
      }}
    >
      {showProgress && <CircularProgress />}
      <div className="px-3 px-md-5">
        <h2 className="fw-light" style={{ fontSize: "2rem", color: "#fdf6e3" }}>Welcome to</h2>
        <h1 className="fw-bold" style={{ fontSize: "3.5rem", color: "#fffacd" }}>NMaaS</h1>
        <h4 className="fw-light" style={{ fontSize: "1.75rem", color: "#f0e68c" }}>{userName}</h4>
        <div className="mt-3 mt-md-4">
          <h5 className="fw-bold" style={{ fontSize: "1.5rem", color: "#ffe4b5" }}>
            Built for Events. Designed for You.
          </h5>
        </div>
      </div>
      <div
        className="monitoring-carousel bg-dark-carousel bg-opacity-100 rounded-4 p-3 p-md-4 position-absolute end-0 me-3 me-md-5 d-flex flex-column justify-content-between"
        style={{
          top: "20%",
          width: "460px",
          height: "460px",
          backdropFilter: "blur(10px)",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
          border: "1px solid rgba(255,255,255,0.2)",
          padding: "2rem"
        }}
      >
        <Carousel
          indicators={true}
          interval={5000}
          fade
          controls={false}
          className="flex-grow-1 d-flex flex-column justify-content-center"
        >
          <Carousel.Item>
            <div className="d-flex flex-column justify-content-center h-100" style={{ fontSize: "1.25rem" }}>
              <h5 className="fw-bold text-white mb-4" style={{ fontSize: "1.75rem" }}>Monitoring Summary</h5>
              <ul className="text-white ps-4" style={{ lineHeight: "2rem", fontSize: "1.25rem" }}>
                <p><strong>Total Events:</strong> {eventCount.count}</p>
                <p><strong>Ongoing:</strong> {eventCount.pcount}</p>
                <p><strong>Upcoming:</strong> 5</p>
                <p><strong>Completed:</strong> 4</p>
              </ul>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="d-flex flex-column justify-content-center h-100" style={{ fontSize: "1.25rem" }}>
              <h5 className="fw-bold text-white mb-4" style={{ fontSize: "1.75rem" }}>Recently Monitored</h5>
              <ul className="text-white ps-4" style={{ lineHeight: "2rem", fontSize: "1.25rem" }}>
                <p><li>Mardi Gras 2026</li></p>
                <p><li>Broncos Game at Empower Field</li></p>
                <p><li>Pittsburgh Steelers Game 9</li></p>
                <p><li>Pittsburgh Steelers Game 8</li></p>
                {/* <p><li>RAGBRAI</li></p> */}
              </ul>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="d-flex flex-column justify-content-center h-100" style={{ fontSize: "1.25rem" }}>
              <h5 className="fw-bold text-white mb-4" style={{ fontSize: "1.75rem" }}>Upcoming Events</h5>
              <ul className="text-white ps-4" style={{ lineHeight: "2rem", fontSize: "1.25rem" }}>
                <p><li>NFL Draft 2026</li></p>
                <p><li>Kentucky Derby 2026</li></p>
                <p><li>KY Oaks & Derby</li></p>
                <p><li>Boston Calling Festival 2026</li></p>
                <p><li>Indy 500 Race</li></p>
              </ul>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  );
}